import { all_information } from '../App';
import { getBusinessLogicConfiguration } from '../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
import Message from './Message/Message';
import { removeParentheses } from './Methods/methods';

export const applyTheRule = async (
  table: string,
  module: string
): Promise<string> => {
  let current_query = '';

  await getBusinessLogicConfiguration({ org_id: all_information.company_id })
    .then((el) => {
      current_query = '';
      el.data.map((elin: any) => {
        if (elin.target_table === table && elin.component_name === module) {
          let theCondition: string = elin.condition.toString();
          let theConditions = theCondition.split(/\s+(or|and|OR|AND)\s+/);
          let theCurrentLogic = 'where';
          theConditions.map((el: string, index: number) => {
            el = removeParentheses(el);
            if (index % 2 === 0) {
              if (el.includes('!=') || el.includes('=')) {
                let cases = el.split(/(!=|=)/);
                current_query += addToQuery(
                  cases[0],
                  cases[1],
                  theCurrentLogic,
                  cases[2]
                );
              }
            } else {
              theCurrentLogic = el + 'Where';
            }
          });
        }
      });
    })
    .catch((er) => {
      Message.error("Can't acces business logic parameter");
      if (er.response) {
        Message.error(
          er.response.data +
            '\n' +
            er.response.status +
            '\n' +
            er.response.headers
        );
      } else if (er.request) {
        Message.error(er.request);
      } else {
        Message.error('Error: ' + er.message);
      }
      Message.error(er.config);
    });
  return current_query;
};
export const addToQuery = (
  field: string,
  c: string,
  type: string,
  v: string
) => {
  let the_current_query: string;
  the_current_query = JSON.stringify({
    f: field,
    c: c,
    t: type,
    v: v.replaceAll(`'`, ''),
  });
  the_current_query += '?';
  return the_current_query;
};
